import CountryDetailMobileTabs from './components/Discovery/countryDetail/CountryDetailMobileTabs';

// Profile uses the Country-detail tab shell so its mobile pill, docking
// backing, overflow fades and active-tab reveal stay in lockstep.
const ProfileMobileTabs = ({ items }) => (
    <CountryDetailMobileTabs
        items={items}
        className="profile-tabs-row"
    />
);

export default ProfileMobileTabs;
